import { format, startOfDay, endOfDay } from 'date-fns';

/**
 * Get user's timezone from browser or fallback to profile timezone
 */
export function getUserTimezone(profileTimezone?: string): string {
  // Use profile timezone if available, otherwise browser timezone
  return profileTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Get today's date in user's timezone as YYYY-MM-DD
 */
export function getTodayInUserTimezone(timezone?: string): string {
  const userTimezone = timezone || getUserTimezone();
  return format(new Date(), 'yyyy-MM-dd');
}

/**
 * Get date range for a specific date in user's timezone
 */
export function getDateRangeInUserTimezone(date: Date, timezone?: string) {
  const userTimezone = timezone || getUserTimezone();
  
  return {
    start: format(startOfDay(date), 'yyyy-MM-dd'),
    end: format(endOfDay(date), 'yyyy-MM-dd'),
    dateString: format(date, 'yyyy-MM-dd')
  };
}

/**
 * Format time in user's timezone
 */
export function formatTimeInUserTimezone(
  dateString: string, 
  timezone?: string,
  options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }
): string {
  const userTimezone = timezone || getUserTimezone();
  return new Date(dateString).toLocaleTimeString('en-US', {
    ...options,
    timeZone: userTimezone,
  });
}

/**
 * Get meal date in user's timezone for storage
 */
export function getMealDateForStorage(date: Date = new Date(), timezone?: string): string {
  const userTimezone = timezone || getUserTimezone();
  // Ensure we're storing the date as it appears to the user in their timezone
  return format(date, 'yyyy-MM-dd');
}